import icon from 'vue-svgicon';

icon.register({
    'regular/bin-paper': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M18.5 22.09a1.544 1.544 0 0 1-1.513 1.16H7.018A1.545 1.545 0 0 1 5.5 22.09L.791 2.59a1.459 1.459 0 0 1 .3-1.273A1.577 1.577 0 0 1 2.3.75h19.4a1.574 1.574 0 0 1 1.217.567 1.463 1.463 0 0 1 .3 1.273zM7.339.75l2.33 22.5M16.662.75l-2.331 22.5M1.796 6.75h20.408M3.247 12.75h17.507M4.697 18.75h14.607" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
